export const addTooltipText = 'Add a new User';
export const searchTooltipText = 'Search by user name, email';
